import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import XLSX from 'xlsx';
import XLSXS from 'xlsx-style';
import { saveAs } from 'file-saver';
import Tool from './tool';
var Excel = {};
Excel.autoWidth = function (ws, data) {
  /* set worksheet max width per col*/
  var colWidth = data.map(function (row) {
    return row.map(function (val) {
      /* if null/undefined*/
      if (val == null) {
        return {
          wch: 20
        };
      }
      /* if chinese*/else if (val.toString().charCodeAt(0) > 255) {
        return {
          wch: val.toString().length * 2 + 10
        };
      } else {
        return {
          wch: val.toString().length + 10
        };
      }
    });
  });
  /* start in the first row*/
  var result = colWidth[0];
  for (var i = 1; i < colWidth.length; i++) {
    for (var j = 0; j < colWidth[i].length; j++) {
      if (result[j]['wch'] < colWidth[i][j]['wch']) {
        result[j]['wch'] = colWidth[i][j]['wch'];
      }
    }
  }
  ws['!cols'] = result;
};
Excel.json2array = function (key, jsonData) {
  if (Tool.isNull(key) || Tool.isNull(jsonData)) {
    return [];
  }
  return jsonData.map(function (v) {
    return key.map(function (j) {
      return v[j];
    });
  });
};

// fix data,return string
var fixdata = function fixdata(data) {
  var o = '';
  var l = 0;
  var w = 10240;
  for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
};
function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  };
  for (var R = 0; R != data.length; ++R) {
    for (var C = 0; C != data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C] || ''
      };
      if (R == 0) {
        cell.s = style.hs;
      } else {
        cell.s = style.bs;
      }
      // if (cell.v == null) continue
      var cell_ref = XLSX.utils.encode_cell({
        c: C,
        r: R
      });
      if (typeof cell.v === 'number') {
        cell.t = 'n';
      } else if (typeof cell.v === 'boolean') {
        cell.t = 'b';
      } else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else {
        cell.t = 's';
      }
      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
  return ws;
}
function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

// get head from excel file,return array
Excel.getHeaderRow = function (sheet) {
  var headers = [];
  var range = XLSX.utils.decode_range(sheet['!ref']);
  var C;
  var R = range.s.r; /* start in the first row */
  for (C = range.s.c; C <= range.e.c; ++C) {
    /* walk every column in the range */
    var cell = sheet[XLSX.utils.encode_cell({
      c: C,
      r: R
    })]; /* find the cell in the first row */
    var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
    if (cell && cell.t) {
      hdr = XLSX.utils.format_cell(cell);
    }
    if (!hdr.startsWith('UNKNOWN')) {
      headers.push(hdr);
    }
  }
  return headers;
};
Excel.exportTableToExcel = function (id, filename) {
  var table = document.getElementById(id);
  var wb = XLSX.utils.table_to_book(table);
  XLSX.writeFile(wb, filename);
};
Excel.exportJsonToExcel = function (_ref) {
  var data = _ref.data,
    key = _ref.key,
    title = _ref.title,
    filename = _ref.filename,
    autoWidth = _ref.autoWidth;
  var wb = XLSX.utils.book_new();
  data.unshift(title);
  var ws = XLSX.utils.json_to_sheet(data, {
    header: key,
    skipHeader: true
  });
  if (autoWidth) {
    var arr = Excel.json2array(key, data);
    Excel.autoWidth(ws, arr);
  }
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + '.xlsx');
};
Excel.exportArrayToExcel = function (_ref2) {
  var key = _ref2.key,
    data = _ref2.data,
    title = _ref2.title,
    filename = _ref2.filename,
    autoWidth = _ref2.autoWidth,
    merges = _ref2.merges;
  var wb = XLSX.utils.book_new();
  var arr = Excel.json2array(key, data);
  arr.unshift(title);
  var ws = sheet_from_array_of_arrays(arr);
  if (merges) {
    ws['!merges'] = merges;
  }
  if (autoWidth) {
    Excel.autoWidth(ws, arr);
  }
  XLSX.utils.book_append_sheet(wb, ws, filename);
  var wbout = XLSXS.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: 'application/octet-stream'
  }), filename + '.xlsx');
  // XLSX.writeFile(wb, filename + '.xlsx')
};
Excel.exportArrayToExcelTwo = function (_ref3) {
  var key = _ref3.key,
    data = _ref3.data,
    data1 = _ref3.data1,
    sheetName = _ref3.sheetName,
    sheetName1 = _ref3.sheetName1,
    title = _ref3.title,
    filename = _ref3.filename,
    autoWidth = _ref3.autoWidth,
    merges = _ref3.merges;
  var wb = XLSX.utils.book_new();
  var arr = Excel.json2array(key, data);
  var arr1 = Excel.json2array(key, data1);
  arr.unshift(title);
  arr1.unshift(title);
  var ws = sheet_from_array_of_arrays(arr);
  var ws1 = sheet_from_array_of_arrays(arr1);
  if (merges) {
    ws['!merges'] = merges;
  }
  if (autoWidth) {
    Excel.autoWidth(ws, arr);
    Excel.autoWidth(ws1, arr1);
  }
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.utils.book_append_sheet(wb, ws1, sheetName1);
  var wbout = XLSXS.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: 'application/octet-stream'
  }), filename + '.xlsx');

  // XLSX.writeFile(wb, filename + '.xlsx')
};
var s2ab = function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
};
Excel.read = function (data, type) {
  var workbook = XLSX.read(data, {
    type: type
  });
  var firstSheetName = workbook.SheetNames[0];
  var worksheet = workbook.Sheets[firstSheetName];
  var header = Excel.getHeaderRow(worksheet);
  var results = XLSX.utils.sheet_to_json(worksheet);
  return {
    header: header,
    results: results
  };
};
var defaultCellStyle = {
  font: {
    name: '宋体',
    sz: 12,
    color: {
      rgb: '000000'
    },
    bold: false,
    italic: false,
    underline: false
  },
  alignment: {
    horizontal: 'top',
    vertical: 'top',
    indent: 0
  }
  // fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "FFFF00" },bdColor: { rgb: "17233d" }},
  // fill: { fgColor: { rgb: "2db7f5"  }}
};
var style = {
  // 表头样式
  hs: {
    font: {
      sz: 12,
      color: {
        rgb: '17233d'
      },
      bold: false,
      italic: false,
      underline: false
    },
    alignment: {
      horizontal: 'top',
      vertical: 'center',
      indent: 0
    },
    hpx: 200,
    fill: {
      bgColor: {
        indexed: 64
      },
      fgColor: {
        rgb: 'ace1fd'
      }
    }
  },
  // 内容样式
  bs: {
    font: {
      name: '宋体',
      sz: 12,
      color: {
        rgb: '17233d'
      },
      bold: false,
      italic: false,
      underline: false
    },
    alignment: {
      horizontal: 'top',
      vertical: 'top',
      indent: 0
    }
  },
  // 注释行样式
  ts: {
    font: {
      sz: 10,
      bold: true
    },
    alignment: {
      vertical: 'center',
      wrapText: true
    },
    fill: {
      bgColor: {
        indexed: 64
      },
      fgColor: {
        rgb: '00B050'
      }
    }
  }
};
export default Excel;